export default {"src":"/_next/static/media/fill-in-blank.9a8dd588.svg","height":40,"width":40};